var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChannelsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.143,
    height: 79,
    viewBox: "0 0 90.143 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "channelsIcon",
    transform: "translate(-159.5 -199.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    "data-name": "Path 11274",
    d: "M292.429,285.571H220v-2.786A2.794,2.794,0,0,1,222.786,280h66.857a2.794,2.794,0,0,1,2.786,2.786Z",
    transform: "translate(-51.643 -68.857)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M335.714,205.571H280v-2.786A2.794,2.794,0,0,1,282.786,200h50.143a2.794,2.794,0,0,1,2.786,2.786Z",
    transform: "translate(-103.286)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M246.357,360H162.786A2.794,2.794,0,0,0,160,362.786v50.143a2.794,2.794,0,0,0,2.786,2.786h83.571a2.794,2.794,0,0,0,2.786-2.786V362.786A2.794,2.794,0,0,0,246.357,360Zm-33.244,28.549-17.084,9.759c-.664.383-1.208.065-1.208-.7v-19.5c0-.766.544-1.084,1.208-.7l17.084,9.759A.73.73,0,0,1,213.114,388.549Z",
    transform: "translate(0 -137.714)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsIcon);
export default __webpack_public_path__ + "static/media/channelsIcon.5f15079a8f4a22572ee01e673ea1e7a0.svg";
export { ForwardRef as ReactComponent };